import { ErrorSubType, ErrorTranslationKeys } from './error-translation-keys';

export const ErrorKeys = {
  UNIQUE_CONSTRAINT: {
    key: 'unique_constraint',
    messageKey: ErrorTranslationKeys.UNIQUE_CONSTRAINT.PREFIX,
    messages: {
      PET_NAME_EXISTS: {
        message: 'A pet with this name already exists for this customer',
        translationKey:
          ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES.PET_NAME_EXISTS,
      },
      EMAIL_EXISTS: {
        message: 'This email is already registered',
        translationKey:
          ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES.EMAIL_EXISTS,
      },
      // Add other specific messages as needed
    },
  },
} as const;

export type ErrorKeyType = keyof typeof ErrorKeys;
export type ErrorKey = (typeof ErrorKeys)[ErrorKeyType]['key'];
export type ErrorMessageKey = (typeof ErrorKeys)[ErrorKeyType]['messageKey'];
export type MessageConfig = {
  message: string;
  translationKey: ErrorSubType;
};

// Helper function to get message key and find matching predefined message
export const getErrorInfo = (
  errorKey: string,
  errorMessages: string[]
):
  | {
      messageKey: ErrorMessageKey;
      matchedMessage: boolean;
      translationKey?: string;
    }
  | undefined => {
  const entry = Object.values(ErrorKeys).find((def) => def.key === errorKey);
  if (!entry) return undefined;

  // Find matching message and its translation key
  const messageConfigs = Object.values(entry.messages) as MessageConfig[];
  const matchedConfig = messageConfigs.find((config) =>
    errorMessages.includes(config.message)
  );

  return {
    messageKey: entry.messageKey,
    matchedMessage: !!matchedConfig,
    translationKey: matchedConfig?.translationKey,
  };
};
